import { GetEventLogoDocument, GetEventSeriesLogoDocument, UploadStatus } from '@/generated/graphql';
import { useQuery } from '@vue/apollo-composable';
import { Ref } from 'vue';

const POLL_INTERVAL_MS = 1000;

function pollWhilePending(status: Ref<UploadStatus | null | undefined>) {
    return () => ({
        enabled: status.value === UploadStatus.Pending,
        pollInterval: POLL_INTERVAL_MS,
    });
}

export function useEventSeriesLogoPolling(seriesId: Ref<string>, status: Ref<UploadStatus | null | undefined>) {
    useQuery(GetEventSeriesLogoDocument, () => ({ id: seriesId.value }), pollWhilePending(status));
}

export function useEventLogoPolling(eventId: Ref<string>, status: Ref<UploadStatus | null | undefined>) {
    useQuery(GetEventLogoDocument, () => ({ id: eventId.value }), pollWhilePending(status));
}
